// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
require('es6-promise').polyfill();
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/index"
import VueForm from 'vue-form'
import './assets/js/config.js'
import { vueFormOptions } from './plugins.js'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/less/default.less'
import './assets/less/redefine.less'
import './assets/less/zhouRedefine.less'
import './assets/addedIcon/iconfont.css'
import './assets/less/common.less'
import * as filters from './assets/js/filters.js'
import eventBus from './eventBus/eventBus'
import $ from 'jquery'

import {
	Pagination,
	Select,
	Option,
	Input,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Menu,
	Submenu,
	MenuItem,
	MenuItemGroup,
	Row,
	Col,
	Form,
	FormItem,
	Radio,
	RadioGroup,
	Checkbox,
	CheckboxGroup,
	Popover,
	Button,
	Table,
	TableColumn,
	Tooltip,
	Dialog,
	DatePicker,
	ColorPicker,
	MessageBox,
	Carousel,
	CarouselItem,
	Loading,
} from 'element-ui'

Vue.use(Pagination)
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Popover)
Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tooltip)
Vue.use(Dialog)
Vue.use(DatePicker)
Vue.use(ColorPicker)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Loading)

// Vue.use(MessageBox)
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;

Vue.use(VueForm, vueFormOptions)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>',
	beforeCreate() {

	}
})

/* 使用自定义filters */
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})

/* 切换路由loading */
let loadingInstance = null;
let routerarr = ['/account',
	'/account/login',
	'/account/register',
	'/account/retrieve',
	'/',
	'/advertiser',
	'/publish',
	'/sdk',
	'/about',
	'/contact',
	'/sdkdoc/androidsdkup',
	'/sdkdoc/iossdkup',
	'/sdkdoc/kyysdkup',
	'/termsservice',
	'/termsprivacy',
];
router.beforeEach(function(to, from, next) {
	next();

	function isEven(num) {
		return num == to.path;
	};
	let someEven = routerarr.some(isEven);
	if(!(someEven)) {
		loadingInstance = Loading.service({
			text: '加载中...',
			background: 'rgba(0, 0, 0, 0.7)',
		});
	};
})
router.afterEach(function() {
	setTimeout(function() {
		loadingInstance && loadingInstance.close();
	}, 700)
})



// WEBPACK FOOTER //
// ./src/main.js